import { gql } from "@apollo/client";

export const DELETE_IMAGE = gql`
  mutation DeleteImage($id: String) {
    deleteImage(id: $id) {
       success
       message
       error
    }
  }
`;